/* eslint-disable */
import React, { useContext } from 'react';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useHistory } from 'react-router-dom';
import UserContext from 'Shared/UserContext';
import { resetLogin } from 'Shared/UserContext/Actions';
import ConfigContext from 'Shared/ConfigContext';
import { setProfile, initPaniers } from 'Shared/ConfigContext/Actions';
import { Divider, Menu, MenuItem } from '@mui/material';
import { WithRolesComponent } from 'HOC/withRoles';
import useUser from 'hooks/useUser';
import { authUrl } from 'Utils/authConfig';
import situationIcon from 'Images/situation_nav_icon.svg';
import cmdIcon from 'Images/cmd_nav_icon.svg';
import factureIcon from 'Images/facture_nav_icon.svg';
import reglementIcon from 'Images/réglement_nav_icon.svg';
import paramIcon from 'Images/param_nav_icon.svg';
import deconnecterIcon from 'Images/déconnecter_nav_icon.svg';

export const logoutAndBackToLogin = (dispatch, configDispatch, history, role) => () => {
  configDispatch(setProfile({}));
  configDispatch(initPaniers([]));
  // Preserve all per-user tutorial timestamps and device ID
  const tutorialKeys = {};
  const deviceId = localStorage.getItem('copima_device_id');
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith('tutorialLastShown_')) {
      tutorialKeys[key] = localStorage.getItem(key);
    }
  }
  localStorage.clear();
  Object.entries(tutorialKeys).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
  // Restore device ID for MFA trust feature
  if (deviceId) {
    localStorage.setItem('copima_device_id', deviceId);
  }
  if (role === 'ROLE_ADMIN') {
    window.location.href = authUrl();
  } else {
    dispatch(resetLogin());
    history.push('/login');
  }
};

const menuItemSx = {
  color: '#1A2B4B',
  py: '6px',
  px: '16px',
  '&:hover': { backgroundColor: '#F0F7FD' },
};

export const SettingsItems = ({ setOpenModalPwd, setOpenModal, handleClose }) => {
  const {
    dispatch,
    state: { user },
  } = useContext(UserContext);
  const { dispatch: configDispatch } = useContext(ConfigContext);

  const history = useHistory();
  const logout = logoutAndBackToLogin(dispatch, configDispatch, history, user.role);
  const isMF = useUser();

  const nav = (path) => { history.push(path); handleClose(); };

  return (
    <>
      <WithRolesComponent allowedRoles={['ROLE_CLIENT']}>
        {!isMF && (
          <>
            <MenuItem sx={menuItemSx} onClick={() => nav('/dashboard')}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: '-8px' }}>
                <img src={situationIcon} alt="" style={{ width: 20, height: 20 }} />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontSize: '14px', fontWeight: 600, color: '#385576' }}>
                Ma situation
              </ListItemText>
            </MenuItem>

            <Divider sx={{ml:'12px',mr:'12px', borderColor: '#E2E8F0' }} />
          </>
        )}

        <MenuItem sx={menuItemSx} onClick={() => nav('/orders')}>
          <ListItemIcon sx={{ minWidth: 'auto',mr: '-8px' }}>
            <img src={cmdIcon} alt="" style={{ width: 20, height: 20 }} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '14px', fontWeight: 600, color: '#385576' }}>
            Mes commandes
          </ListItemText>
        </MenuItem>

        <Divider sx={{ml:'12px',mr:'12px', borderColor: '#E2E8F0' }} />

        <MenuItem sx={menuItemSx} onClick={() => nav('/factures')}>
          <ListItemIcon sx={{ minWidth: 'auto',mr: '-8px' }}>
            <img src={factureIcon} alt="" style={{ width: 20, height: 20 }} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '14px', fontWeight: 600, color: '#385576' }}>
            {isMF ? 'Mes devis' : 'Mes factures'}
          </ListItemText>
        </MenuItem>

        {!isMF && (
          <>
            <Divider sx={{ ml:'12px',mr:'12px', borderColor: '#E2E8F0' }} />

            <MenuItem sx={menuItemSx} onClick={() => nav('/reglements')}>
              <ListItemIcon sx={{ minWidth: 'auto', mr: '-8px' }}>
                <img src={reglementIcon} alt="" style={{ width: 20, height: 20 }} />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ fontSize: '14px', fontWeight: 600, color: '#385576' }}>
                Mes règlements
              </ListItemText>
            </MenuItem>
          </>
        )}

        <Divider sx={{ ml:'12px',mr:'12px', borderColor: '#E2E8F0' }} />

        <MenuItem sx={menuItemSx} onClick={() => nav('/account-settings')}>
          <ListItemIcon sx={{ minWidth: 'auto',mr: '-8px'}}>
            <img src={paramIcon} alt="" style={{ width: 20, height: 20 }} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '14px', fontWeight: 600, color: '#385576' }}>
            Paramètres du compte
          </ListItemText>
        </MenuItem>

        <Divider sx={{ ml:'12px',mr:'12px',borderColor: '#E2E8F0' }} />
      </WithRolesComponent>

      <MenuItem sx={{ ...menuItemSx, '&:hover': { backgroundColor: '#FFF5F5' } }} onClick={logout}>
        <ListItemIcon sx={{ minWidth: 'auto', mr: '-8px' }}>
          <img src={deconnecterIcon} alt="" style={{ width: 20, height: 20 }} />
        </ListItemIcon>
        <ListItemText primaryTypographyProps={{ fontSize: '14px', fontWeight: 600, color: '#EF456E' }}>
          Se déconnecter
        </ListItemText>
      </MenuItem>
    </>
  );
};

const Settings = ({
  anchorEl, setAnchorEl, setOpenModalPwd, setOpenModal,
}) => {
  const openSettings = Boolean(anchorEl?.id === 'settings');

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Menu
      id="menu-appbar"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 50,
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: '12px',
            boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
            width: '260px',
            ml:'10px',
            border: '1px solid #E2E8F0',
            py: '4px',
          },
        },
      }}
      open={openSettings}
      onClose={handleClose}
    >
      <SettingsItems
        setOpenModalPwd={setOpenModalPwd}
        setOpenModal={setOpenModal}
        handleClose={handleClose}
      />
    </Menu>
  );
};

Settings.propTypes = {};

export default Settings;